export enum Join {
  And = 'and',
  Or = 'or',
}

export enum Operator {
  Contains = 'contains',
  ContainsAny = 'contains_any',
  NotContains = 'not_contains',
  Eq = 'eq',
  NotEq = 'not_eq',
  Empty = 'empty',
  NotEmpty = 'not_empty',
  Between = 'between',
  Lte = 'lte',
  Gte = 'gte',
  Gt = 'gt',
  Lt = 'lt',
}
